import { Component, effect, inject, input, output } from '@angular/core';
import { AtpService } from '../../services/atp.service';
import { AtpConfig, ContextConfig } from '../../models/response/AtpConfig';
import { FormArray, FormGroup } from '@angular/forms';
import { FormGroupContextBase } from './models/FormModels';
import { FormGroupAtpHtml } from './models/HtmlModels';
import { VoucherAtpHandlerService } from './service/voucher-atp-handler.service';
import { VoucherAtpHandlerHtmlService } from './service/voucher-atp-handler-html.service';
import { contextBaseExample } from '../../../../common/constants/constants';

@Component({
  selector: 'app-voucher-atp',
  templateUrl: './voucher-atp.component.html',
  styleUrls: ['./voucher-atp.component.scss'],
  standalone: false
})
/** AMSFAAA-350 */
export class VoucherAtpComponent {
  private atpService = inject(AtpService);
  private voucherAtpHandlerService = inject(VoucherAtpHandlerService);
  private voucherAtpHandlerHtmlService = inject(VoucherAtpHandlerHtmlService);

  client_configuration_id = input<number | undefined>();
  canModify = input.required<boolean>();

  formGroupEmit = output<FormArray<FormGroup<FormGroupContextBase>>>();

  atpResponse?: AtpConfig;
  formArray?: FormArray<FormGroup<FormGroupContextBase>>;
  formGroupHtml: FormGroupAtpHtml[] = [];

  constructor() {
    effect(() => {
      if (this.formArray) {
        this.disableEnableControls();
      } else {
        this.loadClientConfiguration();
      }
    });
  }

  private loadClientConfiguration() {
    if (this.client_configuration_id()) {
      this.atpService.getAtpConfiguration(this.client_configuration_id()).subscribe({
        next: (res) => {
          this.atpResponse = res;
          this.createFormGroup(res.contexts);
        },
        error: () => this.createFormGroup({})
      });
    } else {
      this.createFormGroup({});
    }
  }

  private disableEnableControls() {}

  private createFormGroup(contexts: ContextConfig) {
    this.formArray = this.voucherAtpHandlerService.createFormArrayContextConfig(contexts, !this.canModify());
    this.formGroupHtml = this.voucherAtpHandlerHtmlService.createFormGroupAtpHtml(this.formArray);
    this.formGroupEmit.emit(this.formArray);
  }

  addNewFormGroupContextBase() {
    const name = `Default-${this.formGroupHtml.length}`;
    const formGroupContextBase: FormGroup<FormGroupContextBase> = this.voucherAtpHandlerService.createFormGroupContextBase(
      name,
      contextBaseExample,
      !this.canModify()
    );
    const formGroupAtpHtml: FormGroupAtpHtml = this.voucherAtpHandlerHtmlService.createFormGroupFromHtml(name, formGroupContextBase);

    this.formArray.push(formGroupContextBase);
    this.formGroupHtml.push(formGroupAtpHtml);
    this.formArray.markAsDirty();
  }

  removeContextBase(index: number) {
    this.formGroupHtml.splice(index, 1);
    this.formArray.removeAt(index);
  }
}
